<div class="list-container">
  <div class="card-wrapper" *ngFor="let card of CARDS">
    <app-card [card]="card" class="card" [selectable]="true" [isSelected]="(card === selectedCard)"
              [inactive]="inactive" (selected)="onCardSelected(card)"></app-card>
  </div>
</div>

